import { IconProps } from 'src/utils/icon';

const AnnouncementIcon: React.FC<IconProps> = ({ size = 1 }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.7402 16.4283L15.0404 12.7285C14.8734 12.5615 14.6471 12.4688 14.4096 12.4688H13.8047C14.8289 11.1588 15.4375 9.51113 15.4375 7.71875C15.4375 3.45488 11.9826 0 7.71875 0C3.45488 0 0 3.45488 0 7.71875C0 11.9826 3.45488 15.4375 7.71875 15.4375C9.51113 15.4375 11.1588 14.8289 12.4687 13.8047V14.4096C12.4687 14.6471 12.5615 14.8734 12.7285 15.0404L16.4283 18.7402C16.7771 19.0891 17.3412 19.0891 17.6863 18.7402L18.7365 17.69C19.0854 17.3412 19.0854 16.7771 18.7402 16.4283ZM7.71875 12.4688C5.09512 12.4688 2.96875 10.3461 2.96875 7.71875C2.96875 5.09512 5.09141 2.96875 7.71875 2.96875C10.3424 2.96875 12.4687 5.09141 12.4687 7.71875C12.4687 10.3424 10.3461 12.4688 7.71875 12.4688Z"
      fill="#B9B9B9"
    />
  </svg>
);

export default AnnouncementIcon;
